import { jsx as s } from "react/jsx-runtime";
import { memo as c } from "react";
import { Select as p } from "antd";
import { u as f } from "./styled-components.browser.esm-3eb04950.js";
import { useEventResolver as n } from "@biron-data/react-contexts";
const y = c(({
  value: o,
  onChange: e,
  options: r,
  gaevent: t,
  ...l
}) => {
  const i = n();
  return /* @__PURE__ */ s(
    a,
    {
      value: o,
      options: r,
      onChange: (m) => {
        t && i.capture(t), e == null || e(m);
      },
      ...l
    }
  );
}), a = f(p)`
  &&& .ant-select-selection-item {
    display: flex;
    align-items: center;
  }
  
  &&& .ant-select-item-option-content {
    display: flex;
    align-items: center;
  }
`;
export {
  y as default
};
//# sourceMappingURL=SelectSelector.js.map
